/* eslint-disable typescript-extended-rules/file-naming-convention */
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanActivateFn, Router } from '@angular/router';

import { AuthenticationsService } from '../../modules/authentications/authentications.service';
import { PermissionDeniedDialogComponent } from '../../modules/general/permission-denied/permission-denied-dialog.component';
import { isSuperAdmin } from '../utils/is-super-admin.util';

export const claimUsageIngestionSuperUserGuard: CanActivateFn = () => {
	const authenticationsService = inject(AuthenticationsService);
	const dialog = inject(MatDialog);
	const router = inject(Router);

	if (isSuperAdmin(authenticationsService.getSession())) {
		return true;
	}

	dialog.open(PermissionDeniedDialogComponent, {
		data: {
			message: 'Somente usuarios super podem acessar a ingestao de sinistros.',
		},
	});

	return router.createUrlTree(['/inicio']);
};
